<template>
    <div class="timelapse-area">
        <div class="print-background report-section">

            <div class="sub-area">
                <div class="section-title">{{ $t('report.ui.time_lapse_camera') }}</div>
                <br>

                <div class="motto">
                    <!-- <i class="fa fa-quote-left"></i> -->
                    「喔喔喔！長得好快！」
                    <!-- <i class="fa fa-quote-right"></i> -->
                    <div class="description">
                        <p>
                            我們把作物的生長歷程濃縮成90秒的縮時影片了，快來看看。
                        </p>
                    </div>
                </div>

                <div v-if="data.length > 0">
                    
                    <b-row align-h="center">
                        <b-col lg=8>
                            <b-button v-for="(camera, idx_c) in data" :key="idx_c"
                                    :class="get_TabStyle(idx_c)"
                                    @click="tabIndex = idx_c">
                                {{ camera.device_meta.nickname }}
                            </b-button>

                            <div :style="style_Video">
                                <video width="100%" class="video-block" controls preload="none" :poster="data[ tabIndex ].cover">
                                    <source :src="data[ tabIndex ].url" type="video/mp4">
                                    {{ $t('other.browser_does_not_support') }}
                                </video>
                            </div>
                        </b-col>

                        <!-- <b-col lg=6>
                            <div class="tab-block-title">{{ data[ tabIndex ].device_meta.nickname }}</div>
                            <div class="tab-block-sub-title">Device Code: {{ data[ tabIndex ].hashid }}</div>

                            <div class="tab-block-body">
                                <div v-if="data[ tabIndex ].device_meta.description">
                                    {{ data[ tabIndex ].device_meta.description }}
                                </div>
                                <div v-else>
                                    ( {{ $t('menu.no_description') }} )
                                </div>
                            </div>
                        </b-col> -->
                    </b-row>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Array,
        default: function () { return [] }
    },
    data () {
        return {
            tabIndex: 0,
        }
    },
    mounted ()
    {

    },
    computed: {

        style_Video ()
        {
            return {
                backgroundImage: `url("${ this.data[ this.tabIndex ].cover }")`,
                backgroundSize: 'cover',
                marginBottom: '20px',
            }
        },

    },
    methods: {

        get_TabStyle (index)
        {
            let _class = "tab-buttons"
            if ( this.tabIndex == index ) _class += ' active'
            return _class
        },
    },
    
}
</script>

<style lang="scss" scoped>

.timelapse-area
{
    color: white;
    // background-color: rgb(34, 44, 73);
    background-color: rgb(59, 52, 55);
}


.video-block
{
    cursor: pointer;
    border-radius: 0px;
    // max-width: 800px;
    margin-bottom: -6px;
    // border: 2px solid #848383;

    // 浮水印
    // background-color: rgba(20, 25, 23, 0.8) !important;
    // background-blend-mode: lighten;
    // background-image: url("/farm/img/brand/logo3.png");
    // background-position: center 10%;
    // background-repeat: no-repeat;
    // background-size: 160px 40px;
}

</style>